const header = {
	notifications: {
		no_new: "No new notifications",
		not_found: "No notifications found",
		title: "Notifications",
		view_all: "View all notifications",
	},
	search: {
		no_results: "No results found...",
		placeholder: "Search in the portal",
	},
	user_dropdown: {
		roles: {
			owner: "Owner",
			sub_user: "User",
		},
		tabs: {
			cancel_impersonate: "Stop Impersonating Account",
			my_account: "Personal",
			my_company: "Company",
			sign_out: "Sign Out",
		},
	},
};

export default header;
